import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

/* ----------------------------------------------------------
   <dosage-calculator> — weight‑based Amprolium dose tool
---------------------------------------------------------- */
@customElement('dosage-calculator')
export class DosageCalculator extends LitElement {
  createRenderRoot() { return this }

  static properties = {
    species: { type: String },
    weight: { type: Number },
    form: { type: String },
    result: { type: String }
  };

  constructor() {
    super();
    this.species = "chicken";
    this.weight = 0;
    this.form = "liquid";
    this.result = "";
    this._rates = { chicken: 0.01, turkey: 0.012, cattle: 10, goat: 10, sheep: 10, rabbit: 0.012 };
  }

  _calc() {
    if (this.weight <= 0 || isNaN(this.weight)) {
      this.result = "Enter a valid weight";
      return;
    }
    const mg = (this._rates[this.species] ?? 0.01) * this.weight;
    this.result = this.form === "liquid"
      ? `${(mg / 9600 * 1000).toFixed(2)} mL of 9.6% solution per day`
      : `${mg.toFixed(1)} mg of powder per day`;
  }
  render() {
    return html`
        <div class="space-y-6">
          <div class="grid md:grid-cols-3 gap-6">
            <label class="form-control w-full">
              <span class="label-text">Species</span>
              <select class="select select-bordered" @change=${e => this.species = e.target.value}>
                <option value="chicken">Chicken</option>
                <option value="turkey">Turkey</option>
                <option value="cattle">Cattle</option>
                <option value="goat">Goat</option>
                <option value="sheep">Sheep</option>
                <option value="rabbit">Rabbit</option>
              </select>
            </label>
            <label class="form-control w-full">
              <span class="label-text">Weight (kg)</span>
              <input type="number" step="0.1" min="0.1" class="input input-bordered"
                     @input=${e => this.weight = parseFloat(e.target.value)} />
            </label>
            <fieldset class="form-control w-full">
              <span class="label-text">Formulation</span>
              <div class="flex gap-4 pt-2">
                <label class="flex items-center gap-1">
                  <input type="radio" name="form" value="liquid" class="radio" checked
                         @change=${e => this.form = e.target.value} />Liquid
                </label>
                <label class="flex items-center gap-1">
                  <input type="radio" name="form" value="powder" class="radio"
                         @change=${e => this.form = e.target.value} />Powder
                </label>
              </div>
            </fieldset>
          </div>
          <button class="btn btn-success" @click=${this._calc}>Calculate</button>
          <div class="alert bg-base-200 mt-4" role="status">${this.result || "Enter details to view dose."}</div>
        </div>`;
  }
}
